import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios/index';

import Selector from './selector';
import { stateOptions } from '../packs/helpers/form_support';

class StateSelector extends Selector {
  constructor(props) {
    super(props);

    this.state.placeholder = 'State';
    this.setDefaultStates();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.selectedCountry !== this.props.selectedCountry) {
      this.setOptionsForState(newProps.selectedCountry);
      this.setPlaceholder(newProps.selectedCountry);
    }

    super.componentWillReceiveProps(newProps);
  }

  setOptionsForState(countryId) {
    if (countryId) {
      return axios.get(`/countries/${countryId}/states`, { headers: { Accept: 'application/json' } })
        .then((response) => {
          this.setState({
            options: this.stateOptions(response.data),
          });
        });
    } else {
      this.setState({
        options: [],
      });
    }
  }

  setPlaceholder(countryId) {
    if (countryId) {
      return axios.get(`/countries/${countryId}`, { headers: { Accept: 'application/json' } })
        .then((response) => {
          this.setState({placeholder: response.data.administrative_division});
        });
    } else {
      this.setState({placeholder: 'State'});
    }
  }

  validateRequired(value) {
    if (value === '') {
      return `${ this.state.placeholder } is Required`;
    }
  }

  setDefaultStates() {
    this.state.options = stateOptions();
  }

  stateOptions(stateData) {
    return stateData.map((option) => {
      return { label: option.name, value: option.id };
    });
  }
}

StateSelector.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.node.isRequired,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default StateSelector;
